export default __webpack_public_path__ + "static/media/share-no-shadow.7773dc79.svg";